import * as React from 'react'
import styled from 'styled-components'
import areAdsAllowed from '../../../services/ads/areAdsAllowed'

const Wrapper = styled.div`
  display: grid;
  place-content: center;
  min-width: 300px;
  min-height: 250px;
`

export default () => {
  React.useEffect(() => {
    if (
      areAdsAllowed() &&
      process.env.NODE_ENV === 'production' &&
      process.env.REACT_APP_DISABLE_ADS === 'false'
    ) {
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
    }
  }, [])

  if (
    areAdsAllowed() &&
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_DISABLE_ADS === 'false'
  ) {
    return (
      <Wrapper>
        <ins
          className="adsbygoogle"
          style={{ display: 'block', width: 300, height: 250, margin: 'auto' }}
          data-ad-client="ca-pub-7151132540209765"
          data-ad-slot="3258630683"
        ></ins>
      </Wrapper>
    )
  }

  return <></>
}
